export default "__VITE_ASSET__BW4e013D__"